import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import stileGrid from '../../../interfaccia/stileGrid';
import CodiceVSVoceCliccabile from '../../../navigadbsections/CodiceVSVoceCliccabile';
import TraduciCiecamente from '../../../navigadbsections/TraduciCiecamente';
import stilePulsanti from '../../../interfaccia/stilePulsanti';
import DatoBooleanModificabileInLinea2 from '../../../navigadbsections/DatoBooleanModificabileInLinea2';
import DatoModificabileInLinea from '../../../navigadbsections/DatoModificabileInLinea';

function ListaArticoliAreaAnteprimaExport({ setProductFunction, listaArticoli, utente, tradPermessa }) {

  const [rows, setRows] = useState(
    listaArticoli
  )

  useEffect(() => {
    setRows(listaArticoli)
  }, [listaArticoli]);



  const columns = [
    {
      field: 'codiceVS',
      headerName: 'VS',
      width: 50,
      renderCell: (params) => {
        if (params.row.codiceVS) {
          return <CodiceVSVoceCliccabile codiceVS={params.row.codiceVS} setProductFunction={setProductFunction} utente={utente} />
        }
        else { return <div className="rowitem">X</div> }
      }
    },
    {
      field: 'shortName',
      valueGetter: (params) => params.row.shortName?.it ?? "N/A",
      headerName: 'S.NAME',
      width: 200,
    },
    {
      field: 'titIT',
      /* valueGetter: (params) => params.row.titIT ?? "N/A", */
      headerName: 'TIT IT',
      width: 300,
      renderCell: (params) => {
        if (params.row.titIT) {
          return <DatoModificabileInLinea idDocumento={params.row._id} dato={params.row.titIT} nomeDato="descrizioniSuPS.titolo.it" setProductFunction={setProductFunction} />
        }
        else { return <DatoModificabileInLinea idDocumento={params.row._id} dato="" nomeDato="descrizioniSuPS.titolo.it" setProductFunction={setProductFunction} /> }
      }
    },
    {
      field: 'titEN',
      /* valueGetter: (params) => params.row.descrizioniSuPS?.titolo?.en ?? "N/A", */
      headerName: 'TIT EN',
      /* headerClassName: 'fw7', */
      width: 300,
      renderCell: (params) => {
        if (params.row.titEN) {
          return <DatoModificabileInLinea idDocumento={params.row._id} dato={params.row.titEN} nomeDato="descrizioniSuPS.titolo.en" setProductFunction={setProductFunction} />
        }
        else { return <DatoModificabileInLinea idDocumento={params.row._id} dato="" nomeDato="descrizioniSuPS.titolo.en" setProductFunction={setProductFunction} /> }
      }
    },
    {
      field: 'titFR',
      /* valueGetter: (params) => params.row.descrizioniSuPS?.titolo?.fr ?? "N/A", */
      headerName: 'TIT FR',
      /* headerClassName: 'fw7', */
      width: 300,
      renderCell: (params) => {
        if (params.row.titFR) {
          return <DatoModificabileInLinea idDocumento={params.row._id} dato={params.row.titFR} nomeDato="descrizioniSuPS.titolo.fr" setProductFunction={setProductFunction} />
        }
        else { return <DatoModificabileInLinea idDocumento={params.row._id} dato="" nomeDato="descrizioniSuPS.titolo.fr" setProductFunction={setProductFunction} /> }
      }
    },
    {
      field: 'lunghezzaDescLungaIT',
      valueGetter: (params) => params.row.lunghezzaDescLungaIT ?? "N/A",
      headerName: 'IT #char',
      width: 100
    },
    {
      field: 'startDescLungaFR',
      valueGetter: (params) => params.row.startDescLungaFR === "..." ? "" : params.row.startDescLungaFR ?? "N/A",
      headerName: 'FR desc',
      width: 400
    },
    {
      field: '_id', headerName: 'traduci', width: 75,
      renderCell: (params) => {
        const cambiaStato = function () {
          params.row.tradotto.en = true
          setRows(
            [
              ...rows
            ]
          )
        }
        if (!params.row.tradotto) {
          params.row.tradotto = {
            en: params.row.tradEN
          }
        }
        if (tradPermessa) {
          return (<TraduciCiecamente idProd={params.row._id} trad={params.row.tradotto?.en ? params.row.tradotto.en : false} setProductFunction={setProductFunction} cambiaStato={cambiaStato} nonAprireDopoTrad={true}/>)
        } else {
          return (<div>{stilePulsanti.bloccoTradAspetto}</div>)
        }
      }
    },
    /* {
      field: 'esportato',
      headerName: 'Esporta',
      width: 80,
      renderCell: (params) => {
        if (params.row.esportato) {
           return <DatoBooleanModificabileInLinea idDocumento={params.row._id} switchColori="0" displayTrue="SI" displayFalse="NO" datoAttuale="1" nomeDato="esportato" setProductFunction={setProductFunction} /> } 
           else { return <DatoBooleanModificabileInLinea idDocumento={params.row._id} switchColori="0" displayTrue="SI" displayFalse="NO" datoAttuale="0" nomeDato="esportato" setProductFunction={setProductFunction} /> }      }
    },
    {
      field: 'tradEN',
      headerName: 'Trad S/N',
      width: 80,
      valueGetter: (params) => params.row.tradEN ? "S" : "N",
      
      renderCell: (params) => {
        if (params.row.tradEN) {
           return <DatoBooleanModificabileInLinea idDocumento={params.row._id} switchColori="0" displayTrue="SI" displayFalse="NO" datoAttuale="1" nomeDato="tradotto.en" setProductFunction={setProductFunction} /> } 
           else { return <DatoBooleanModificabileInLinea idDocumento={params.row._id} switchColori="0" displayTrue="SI" displayFalse="NO" datoAttuale="0" nomeDato="tradotto.en" setProductFunction={setProductFunction} /> }      }
     
          } */
    {
      field: 'esportato',
      headerName: 'Esporta',
      width: 80,
      renderCell: (params) => {
        if (params.row.esportato) {
          return <DatoBooleanModificabileInLinea2 idDocumento={params.row._id} colTrueAttuale="rosso" testoTrueAttuale="NO" testoFalseAttuale="SI" valoreAttuale="1" nomeDato="esportato" setProductFunction={setProductFunction} />
        }
        else { return <DatoBooleanModificabileInLinea2 idDocumento={params.row._id} colTrueAttuale="rosso" testoTrueAttuale="NO" testoFalseAttuale="SI" valoreAttuale="0" nomeDato="esportato" setProductFunction={setProductFunction} /> }
      }
    },
    {
      field: 'tradEN',
      headerName: 'Trad S/N',
      width: 80,
      valueGetter: (params) => params.row.tradEN ? "S" : "N",

      renderCell: (params) => {
        if (params.row.tradEN) {
          return <DatoBooleanModificabileInLinea2 idDocumento={params.row._id} colTrueAttuale="verde" testoTrueAttuale="SI" testoFalseAttuale="NO" valoreAttuale="1" nomeDato="tradotto.en" setProductFunction={setProductFunction} />
        }
        else { return <DatoBooleanModificabileInLinea2 idDocumento={params.row._id} colTrueAttuale="verde" testoTrueAttuale="SI" testoFalseAttuale="NO" valoreAttuale="0" nomeDato="tradotto.en" setProductFunction={setProductFunction} /> }
      }

    }
  ];

  return (
    <div
      className="colonnaTuttaPagina"
    >
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row._id}
        autoPageSize
        rowsPerPageOptions={[10, 20, 50]}

        pagination
        sx={stileGrid}
      />
      
    </div>
  )
}


export default ListaArticoliAreaAnteprimaExport;

